import React from 'react';
import { Modal } from 'antd';
import type { ApprovalResponsibilitySummary } from '@/services/user.service';

export function handoverMocUrl(fromUserId: string, reason: 'leave' | 'resignation' | 'termination' | 'other'): string {
  const qs = new URLSearchParams({ changeType: 'KEY_PERSONNEL', fromUser: fromUserId, reason });
  return `/grc/moc/new?${qs.toString()}`;
}

export function describeResponsibilities(summary: ApprovalResponsibilitySummary): string[] {
  const lines: string[] = [];
  if (summary.pending_approvals) lines.push(`${summary.pending_approvals} pending approval(s) assigned to them`);
  if (summary.process_owner_departments.length) {
    lines.push(`Process Owner of ${summary.process_owner_departments.join(', ')}`);
  }
  if (summary.workflow_steps) lines.push(`Named approver / escalation user on ${summary.workflow_steps} workflow step(s)`);
  return lines;
}

/** After deactivation / exit: offer a Key Personnel MOC when the user still holds approvals. */
export function promptHandoverIfNeeded(params: {
  summary?: ApprovalResponsibilitySummary | null;
  userId?: string | null;
  personLabel: string;
  reason: 'resignation' | 'termination' | 'other';
  navigate: (url: string) => void;
}): void {
  const { summary, userId } = params;
  if (!summary?.has_any || !userId) return;
  Modal.confirm({
    title: `${params.personLabel} still holds approval responsibilities`,
    content: (
      <div>
        <ul style={{ paddingLeft: 18, marginBottom: 8 }}>
          {describeResponsibilities(summary).map((l) => (
            <li key={l}>{l}</li>
          ))}
        </ul>
        Documents assigned to them will stay stuck until these are handed over. Raise a Key Personnel MOC to move them
        to a successor.
      </div>
    ),
    okText: 'Raise handover MOC',
    cancelText: 'Later',
    onOk: () => params.navigate(handoverMocUrl(userId, params.reason)),
  });
}
